import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class SecureGuard implements CanActivate {
  constructor(private router: Router, private store: StorageService) {}
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const apikey = this.store.data.apikey;
    const termsAccepted = this.store.data.termsAccepted;
    const termsAgreeDate = this.store.data.termsAgreeDate;
    const termsUpdatedDate = this.store.data.termsUpdatedDate;
    const getWAConsentByUser = this.store.data.getWAConsentByUser;

    if (!apikey) {
      this.router.navigate(['/login']);
      return false;
    }

    // Check if terms are accepted
    if (apikey && !termsAccepted) {
      this.router.navigate(['/terms']);
      return false;
    }

    // If terms are accepted, check if they need to be re-accepted due to updates
    if (apikey && termsAgreeDate && termsUpdatedDate) {
      try {
        const agreeDate = new Date(termsAgreeDate.replace(' ', 'T')).getTime();
        const updateDate = new Date(
          termsUpdatedDate.replace(' ', 'T')
        ).getTime();

        if (agreeDate < updateDate) {
          this.router.navigate(['/terms']);
          return false;
        }
      } catch (error) {
        console.error('Date parsing error:', error);
        // If there's an error parsing dates, redirect to terms as a precaution
        this.router.navigate(['/terms']);
        return false;
      }
    }

    // Check WhatsApp consent after terms validation
    if (apikey && termsAccepted && !getWAConsentByUser) {
      this.router.navigate(['/whatsapp-consent']);
      return false;
    }

    return true;
  }
}
